export function updateOrg (data) {
  return dispatch => dispatch({ type: 'SET_ORG', payload: data })
}

export function updateOrgData (data) {
  return dispatch => dispatch({ type: 'SET_ORG_DATA', payload: data })
}
